import { render, staticRenderFns } from "./AvatarGroupOverlap.vue?vue&type=template&id=e4c08ca6"
import script from "./AvatarGroupOverlap.vue?vue&type=script&lang=js"
export * from "./AvatarGroupOverlap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports